var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212-220.62v-51.99h40.31v-258.47q0-84.69 53.31-148.19 53.3-63.5 136.38-76.81V-806q0-15.83 11.07-26.92Q464.14-844 479.95-844q15.82 0 26.93 11.08Q518-821.83 518-806v49.92q83.08 13.31 136.38 76.81 53.31 63.5 53.31 148.19v258.47H748v51.99H212Zm268-269.07Zm-.28 381.38q-26.64 0-45.33-18.89-18.7-18.89-18.7-45.42h128.62q0 26.93-18.98 45.62-18.97 18.69-45.61 18.69Zm-175.41-164.3h351.38v-258.47q0-73.46-51.11-124.57-51.12-51.12-124.58-51.12-73.46 0-124.58 51.12-51.11 51.11-51.11 124.57v258.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsWhite);
export default __webpack_public_path__ + "static/media/notificationsWhite.3abc82e9ea1e14601f3cea941f9e5791.svg";
export { ForwardRef as ReactComponent };